import { BookingStepKey } from "../constants/bookingSteps";
import { BookingStepUrlsState } from "./bookingStepUrlsReducer";

type WithBookingStepUrls = { bookingStepUrls?: BookingStepUrlsState };

export const getBookingStepUrls = (
	state: WithBookingStepUrls
): Partial<Record<BookingStepKey, string>> => state.bookingStepUrls?.urlsByStep ?? {};

export const getBookingStepUrl = (
	state: WithBookingStepUrls,
	step: BookingStepKey
): string | undefined => getBookingStepUrls(state)[step];
